import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { SessionService } from '../services/session.service';

@Injectable()
export class AuthGuard {
  constructor(
    private router: Router,
    private sessionService: SessionService,
  ) {}

  public canActivate: CanActivateFn = (
    _next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean => {
    const token: string = this.sessionService.getToken();

    if (token) {
      return true;
    } else if (state.url === '/reports') {
      this.router.navigate(['/login'], { queryParams: { page: 'reports' } });
      return false;
    } else {
      this.sessionService.logout();
      return false;
    }
  };
}
